import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";
import { IPageResource } from "../types";

export type IPageDeleteMutationParameters = {
    page: RelationalValue<IPageResource>;
};

export type IPageDeleteMutationResult = void;

export const pageDeleteMutation: IApiMutationFunction<IPageDeleteMutationParameters> = ({ page }) => {
    return {
        method: "DELETE",
        url: `/pages/${mapRelationalValue(page)}`,
    };
};

export const usePageDeleteMutation = createApiMutationHook<IPageDeleteMutationParameters, IPageDeleteMutationResult>(
    pageDeleteMutation,
);
